import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import * as Fi from 'react-icons/fi';
import { BiAddToQueue } from 'react-icons/bi';
import cn from 'classnames';

import { Table, Customer, Services } from 'services/action';

import { Page, Button } from 'ui/components';
import useTable from 'ui/components/table';
import { SkeletonTable, SkeletonPageFooter } from 'ui/components/skeleton';

import tableConfig from './component/table.config';
import CustomerForm from './component/form';
import BulkImport from 'ui/screens/authorized/master/customer/component/create/bulk';
import SingleInput from 'ui/screens/authorized/master/customer/component/create/single';
import { FormBulkUpdate } from 'ui/screens/authorized/master/customer/component/create/form';
import TableImport from 'ui/screens/authorized/master/customer/component/create/tabel.import';

const initialState = {
  isShow: false,
  isWarning: false,
  hasService: false,
  imports: [],
  update: null,
  types: null, // single or bulk_import
};

const CustomerScreen = () => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const CustomerTable = useTable('customer', tableConfig);
  const StateTable = useSelector((state) => state?.Table?.data['customer']);
  const StateForm = useSelector((state) => state.Form);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Table.Request']
  );

  const [{ isShow, isWarning, hasService, imports, update, types }, setState] =
    React.useState(initialState);

  const $onCheckService = async () => {
    const req = await Dispatch(Services.$getType());

    if (req?.message === 'success') {
      if (req?.data && req?.data?.length > 0) {
        setState((prevState) => ({ ...prevState, hasService: true }));
      } else {
        setState((prevState) => ({ ...prevState, hasService: false }));
      }
    }
  };

  const $handleClose = () => {
    setState((prevState) => ({
      ...prevState,
      isWarning: false,
      isShow: false,
      imports: [],
      update: null,
      types: null,
    }));
  };

  const $resetTable = async () => {
    $handleClose();
    Dispatch(Table.$reload('customer', StateTable));
  };

  const $handleUpdate = async (d, id) => {
    const u = { id: id, data: imports[id] };
    setState((prevState) => ({
      ...prevState,
      update: u,
    }));
  };

  const $handleDelete = async (id) => {
    let newList = [...imports];
    newList.splice(id, 1);
    setState((prevState) => ({
      ...prevState,
      imports: newList,
      update: null,
    }));
  };

  const $onUpdate = async (d) => {
    let newList = [...imports];
    newList[update?.id] = d;

    setState((prevState) => ({
      ...prevState,
      imports: newList,
      update: null,
    }));
  };

  const $handleSubmit = async (c) => {
    const payload = {
      datas: imports,
    };

    const req = await Dispatch(Customer.$createBulk(payload));

    if (req?.message === 'success') {
      $resetTable();
    }
  };

  React.useEffect(() => {
    $onCheckService();
  }, []);

  return (
    <Page className="col-12 p-md-4 bg-white h-100" isOnboarding>
      <Page.Header
        isOnboarding={
          <div className="py-3 px-0 mt-5 mt-md-0">
            <div
              className="fw-semibold title mb-2 p-0"
              style={{ fontSize: 26 }}
            >
              Customer
            </div>
            <div
              className="page-pretitle fw-normal"
              style={{ textTransform: 'none', fontSize: 12 }}
            >
              Masukkan data customer untuk memudahkan Anda mengatur shipment
            </div>
          </div>
        }
        className="p-0"
      />
      <Page.Body className="p-md-3 px-3">
        <div className="sub-page-navigation mt-4 mt-md-0">
          <CustomerTable.Tools>
            <button
              onClick={() =>
                setState((prevState) => ({ ...prevState, isShow: true }))
              }
              className="btn btn-primary py-1 ms-1"
            >
              <BiAddToQueue color="white" size="14" />
              <span className="d-none d-md-block ms-2">Tambah Customer</span>
            </button>
          </CustomerTable.Tools>
        </div>
        <div className="sub-page-body">
          <div className="row m-0 p-0">
            <div className="col-md-12 m-0 p-0">
              {StateLoading ? (
                <SkeletonTable headerCount={4} bodyCount={10} />
              ) : (
                <CustomerTable.Render />
              )}
            </div>
          </div>
        </div>
        <div className="sub-page-footer mt-2">
          {StateLoading ? <SkeletonPageFooter /> : <CustomerTable.Pagination />}
        </div>

        <Modal
          show={isShow}
          onHide={$handleClose}
          backdrop="static"
          centered
          scrollable
          size="xl"
          enforceFocus={true}
        >
          <Modal.Header closeButton>
            <Modal.Title>Tambah Customer</Modal.Title>
          </Modal.Header>

          {(types === null ||
            (types === 'bulk_import' && imports?.length) === 0) && (
            <div className="row border bg-white m-0">
              <div className="col-md-5 border-bottom-sm d-flex justify-content-center align-items-center">
                <BulkImport
                  onImported={(e) =>
                    setState((prevState) => ({
                      ...prevState,
                      imports: [...prevState?.imports, e],
                      types: 'bulk_import',
                      update: null,
                    }))
                  }
                />
              </div>
              <div className="col-md-2 d-flex justify-content-center align-items-center  position-relative">
                <div
                  className="position-absolute top-50 start-50 translate-middle d-none d-md-flex"
                  style={{
                    height: 150,
                    width: 0.5,
                    backgroundColor: '#848484',
                  }}
                />
                <div
                  className="rounded-circle bg-white d-flex justify-content-center align-items-center fs-8 text-uppercase fw-bold text-grey"
                  style={{
                    width: 70,
                    height: 70,
                    zIndex: 9,
                    border: '1px solid #848484',
                  }}
                >
                  atau
                </div>
              </div>
              <div className="col-md-5  d-flex justify-content-center align-items-center">
                <SingleInput
                  onPress={(e) =>
                    setState((prevState) => ({
                      ...prevState,
                      types: 'single',
                      imports: [],
                      update: null,
                    }))
                  }
                />
              </div>
            </div>
          )}

          {types === 'bulk_import' && imports?.length > 0 && (
            <>
              <Modal.Body>
                {update ? (
                  <FormBulkUpdate
                    data={update?.data}
                    onSubmit={$onUpdate}
                    onClose={() => {
                      setState((prevState) => ({ ...prevState, update: null }));
                    }}
                  />
                ) : null}

                <div className="mt-3">
                  <TableImport
                    data={imports}
                    onDelete={$handleDelete}
                    onUpdate={$handleUpdate}
                  />
                </div>
              </Modal.Body>

              <Modal.Footer>
                <div className="row w-100">
                  <div className="col">
                    <Button
                      type="button"
                      className="btn btn-light w-100"
                      onClick={() => $handleClose()}
                    >
                      Batal
                    </Button>
                  </div>
                  <div className="col">
                    <Button
                      type="button"
                      className={cn(
                        StateForm?.loading ? 'btn-loading' : '',
                        'btn btn-primary w-100'
                      )}
                      disabled={StateForm?.loading}
                      onClick={$handleSubmit}
                    >
                      Simpan
                    </Button>
                  </div>
                </div>
              </Modal.Footer>
            </>
          )}
          {types === 'single' && <CustomerForm onClose={$handleClose} />}
        </Modal>
      </Page.Body>

      <Page.Footer className="justify-content-center gap-2 pt-3 border-top d-md-flex d-block mb-3 flex-wrap">
        <Button
          type="button"
          className="btn-secondary py-3"
          onClick={() => {
            if (hasService) {
              History.push('/onboarding-pricing');
            } else {
              History.push('/onboarding-services');
            }
          }}
        >
          Sebelumnya
        </Button>
        <Button
          type="button"
          className="btn-primary py-3"
          onClick={() => {
            if (StateTable?.customer?.length === 0 || StateTable === null) {
              setState((prevState) => ({
                ...prevState,
                isWarning: true,
              }));
            } else {
              History.push('/onboarding-vendor');
            }
          }}
        >
          Selanjutnya
        </Button>
      </Page.Footer>

      <Modal
        show={isWarning}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-warning" />
          <Fi.FiAlertTriangle className="mb-2 text-warning" size={90} />
          <h3>Anda belum memasukan data customer</h3>
          <p className="text-warning fw-semibold">
            Data customer diperlukan untuk mengatur pembuatan shipment.
          </p>
          <p className="text-secondary fw-semibold">
            Pengisian data customer dapat dilakukan nanti.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-between align-items-center w-100 gap-2">
            <div className="">
              <Button className="btn btn-white" onClick={$handleClose}>
                Batal
              </Button>
            </div>
            <div className="">
              <Button
                className={'btn btn-warning'}
                onClick={() => {
                  History.push('/onboarding-vendor');
                }}
              >
                Atur nanti
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </Page>
  );
};

export default CustomerScreen;
